import { buildEnvironmentFilters } from 'src/apps/dashboard/services/queries/dashboard/helpers/environmentFilterBuilder';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import {
	calculateRecentPeriodDates,
	formatDateForGraphQL
} from 'src/common/helpers/DateFormatHelper';
import { ConditionOperators } from 'src/common/types/graphql.generated';

import { BusinessUnitsTableDataQueryVariables } from '../BusinessUnitsTable.generated';

interface IBusinessUnitsTableParams {
	days: number;
	filters?: IFilterOptions;
}

const HISTORIC_DATE_SAFETY_NET_DAYS = 1;
const CURRENT_DATE_SAFETY_NET_DAYS = 1;

const getDateWithDayOffset = (date: Date, offsetDays: number): Date => {
	const result = new Date(date);
	result.setUTCDate(date.getUTCDate() + offsetDays);
	return result;
};

const getHistoricDateCandidates = (currentDate: Date, days: number): Date[] => {
	const historicDate = getDateWithDayOffset(currentDate, -days);
	return [
		getDateWithDayOffset(historicDate, -HISTORIC_DATE_SAFETY_NET_DAYS),
		historicDate,
		getDateWithDayOffset(historicDate, HISTORIC_DATE_SAFETY_NET_DAYS)
	];
};

export const buildBusinessUnitsTableVariables = ({
	days,
	filters
}: IBusinessUnitsTableParams): BusinessUnitsTableDataQueryVariables => {
	const { today: todayDate } = calculateRecentPeriodDates(days);
	const environmentConfig = buildEnvironmentFilters(filters);
	const currentDateCandidates = [
		getDateWithDayOffset(todayDate, -CURRENT_DATE_SAFETY_NET_DAYS),
		todayDate
	];
	const calculationDates = [
		...currentDateCandidates.flatMap((currentDate) => getHistoricDateCandidates(currentDate, days)),
		...currentDateCandidates
	];

	return {
		days,
		calculationDates: {
			operator: ConditionOperators.Any,
			value: [...new Set(calculationDates.map(formatDateForGraphQL))]
		},
		...(environmentConfig?.scoreFilter && {
			environmentFilter: environmentConfig.scoreFilter
		})
	};
};
